import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import PrimeVue from 'primevue/config'
import store from './store'
import router from './router'
import VueToastr from '@deveodk/vue-toastr'

import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css'
import 'primevue/resources/themes/saga-blue/theme.css'
import 'primevue/resources/primevue.min.css'
import 'primeicons/primeicons.css'

Vue.config.productionTip = false

Vue.use(PrimeVue)
Vue.use(VueToastr, {
  defaultPosition: 'toast-bottom-right',
  defaultType: 'info',
  defaultTimeout: 5500
})

new Vue({
  vuetify,
  store,
  router,
  render: h => h(App)
}).$mount('#app')

